import React from 'react';
import { Color, setColor } from 'src/styles/colors';

interface UnlockProps {
  width?: string | number;
  color?: Color;
}

const Unlock = ({ width = '22', color = 'greyText' }: UnlockProps): JSX.Element => (
  <svg
    width={width}
    viewBox='0 0 22 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.7959 7.25V9.5H18.0459C19.6865 9.5 21.0459 10.8594 21.0459 12.5V21.5C21.0459 23.1875 19.6865 24.5 18.0459 24.5H3.0459C1.3584 24.5 0.0458984 23.1875 0.0458984 21.5V12.5C0.0458984 10.8594 1.3584 9.5 3.0459 9.5H3.7959V7.25C3.7959 3.54688 6.7959 0.5 10.5459 0.5C13.2178 0.5 15.5615 2.09375 16.6396 4.39062C16.9678 5.14062 16.6396 6.03125 15.8896 6.35938C15.1865 6.73438 14.249 6.40625 13.9209 5.65625C13.3115 4.39062 11.999 3.5 10.5459 3.5C8.43652 3.5 6.7959 5.1875 6.7959 7.25Z'
      fill={setColor(color)}
    />
  </svg>
);

export default Unlock;
